import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import router from './routes/Router';
import './css/globals.css';

function App() {
  return (
    <>
      <RouterProvider router={router} />
      {/* Mounted once, here. Without it every toast in the app is a silent no-op. */}
      <Toaster position="bottom-right" richColors closeButton />
    </>
  );
}

export default App;
